"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtVersion = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtVersion = function SvgBtVersion(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#sb_version__clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.1665 21.9999H7.83361C6.8223 21.9999 6.00031 21.1779 6.00031 20.1666V14.5002C6.00031 14.2242 6.2243 14.0002 6.50029 14.0002C6.77628 14.0002 7.00027 14.2242 7.00027 14.5002V20.1666C7.00027 20.6259 7.37428 20.9999 7.83361 20.9999H20.1665C20.6259 20.9999 20.9997 20.6259 20.9997 20.1666V10.5003C20.9997 10.041 20.6259 9.66696 20.1665 9.66696H17.8332C17.5572 9.66696 17.3333 9.44297 17.3333 9.16697C17.3333 8.89098 17.5572 8.66699 17.8332 8.66699H20.1665C21.1778 8.66699 21.9997 9.48898 21.9997 10.5003V20.1666C21.9997 21.1779 21.1778 21.9999 20.1665 21.9999Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.4998 16.6668C17.3153 16.6668 17.1412 16.5641 17.0546 16.3942L17.0459 16.3775C16.1066 14.4989 14.222 13.3337 12.1254 13.3337H11.3335V15.5002C11.3335 15.7042 11.2094 15.8875 11.0201 15.9642C10.8329 16.0409 10.6148 15.9942 10.4735 15.8469L6.14028 11.3471C5.95365 11.1537 5.95365 10.8471 6.14028 10.6537L10.4735 6.15389C10.6141 6.00595 10.8315 5.95993 11.0201 6.03659C11.2094 6.11324 11.3335 6.29659 11.3335 6.50056V8.6671H11.5001C15.084 8.6671 17.9998 11.583 17.9998 15.1669V16.1668C17.9998 16.3981 17.8419 16.5988 17.6165 16.6529C17.5778 16.6622 17.5385 16.6668 17.4998 16.6668ZM10.8335 12.3337H12.1254C14.0074 12.3337 15.7453 13.1276 16.9579 14.4809C16.6193 11.771 14.3006 9.66707 11.5001 9.66707H10.8335C10.5575 9.66707 10.3335 9.44308 10.3335 9.16708V7.7405L7.19432 11.0004L10.3335 14.2603V12.8337C10.3335 12.5577 10.5575 12.3337 10.8335 12.3337Z",
    fill: "currentColor"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "sb_version__clip0"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  }))));
};

exports.SvgBtVersion = SvgBtVersion;